export enum AssetMaintenanceCycleType {
    None = -1,
    LessThanWeek = 0,
    InMonth = 1,
    InThreeMonths = 2,
    InSixMonths = 3,
    InYear = 4,
    WithinTwoYeas = 5
}

export const AssetMaintenanceCycleTypeOptions = [
    { key: AssetMaintenanceCycleType.None, value: 'None' },
    { key: AssetMaintenanceCycleType.LessThanWeek, value: 'Less than a week' },
    { key: AssetMaintenanceCycleType.InMonth, value: 'In a month' },
    { key: AssetMaintenanceCycleType.InThreeMonths, value: 'In three months' },
    { key: AssetMaintenanceCycleType.InSixMonths, value: 'In six months' },
    { key: AssetMaintenanceCycleType.InYear, value: 'In a year' },
    { key: AssetMaintenanceCycleType.WithinTwoYeas, value: 'Within two years' }
]